module.exports = __webpack_public_path__ + "static/media/sort-shapes-up.3e813f76.svg";